module.exports = __webpack_public_path__ + "img/slide23.6d5e6611.png";